module.exports = __webpack_public_path__ + "static/images/phone.32c0d35be246d8775a719cd47fd62849.svg";